import React, { FC, useState } from 'react'
import { Card, IconButton, Stack, Text, ThumbsIcon } from '@instabox/consumer-web-ui'
import { FormattedMessage } from 'react-intl'
import { motion } from 'framer-motion'
import { GetMarketByIdQuery } from '@instabox/consumer-web-shared'

import NegativeRating from './NegativeRating'
import PositiveRating from './PositiveRating'

export type Rating = 'idle' | 'positive' | 'negative'

const FAQRating: FC<GetMarketByIdQuery['marketById']> = ({ ...market }) => {
  const [rating, setRating] = useState<Rating>('idle')

  return (
    <Card variant="info" size="md" disableElevation>
      <Stack>
        <Text fontSize="sm" align="center">
          <FormattedMessage id="help.rating.question" />
        </Text>
        <div className="row justify-content-center">
          <div className="col-auto">
            <RatingButton
              label="Vote up"
              size="large"
              variant="light"
              active={rating === 'positive'}
              autoIconWidth
              icon={<ThumbsIcon thumbs="up" />}
              onClick={() => setRating('positive')}
              animate={rating === 'positive' ? 'active' : 'idle'}
              variants={ratingButtonVariants('positive')}
            />
          </div>
          <div className="col-auto">
            <RatingButton
              label="Vote down"
              size="large"
              variant="light"
              active={rating === 'negative'}
              autoIconWidth
              icon={<ThumbsIcon thumbs="down" />}
              onClick={() => setRating('negative')}
              animate={rating === 'negative' ? 'active' : 'idle'}
              variants={ratingButtonVariants('negative')}
            />
          </div>
        </div>
        {rating === 'positive' && (
          <motion.div {...ratingAnimation}>
            <PositiveRating />
          </motion.div>
        )}
        {rating === 'negative' && (
          <motion.div {...ratingAnimation}>
            <NegativeRating {...market} />
          </motion.div>
        )}
      </Stack>
    </Card>
  )
}

export default FAQRating

const RatingButton = motion(IconButton)

const ratingButtonVariants = (rating: Rating) => {
  const y = rating === 'negative' ? -4 : 4
  return {
    active: {
      y: [y, 0, y, 0],
    },
    idle: {
      y: 0,
    },
  }
}

const ratingAnimation = {
  transition: {
    duration: 0.5,
  },
  initial: { opacity: 0 },
  animate: { opacity: 1 },
}
